import ReactDOM from 'react-dom';

/**
 * IMPORTANT: This method is a temporal utility to help in the migration from
 * React v16 to v18 taken from 
 * https://gitlab.tcc.li/climate/cfvweb/farmer-navigation/-/blob/master/src/utils/renderUsingContextVersion.js. 
 * It should be removed after the migration is completed.
 *
 * Render a component using the correct react-dom APIs dependending
 * on the ReactDOM version available in the context of execution.
 *
 * @param {Object} component React node to be rendered.
 * @param {Object} DOMEl DOM Element
 * @return {Object} ReactDOM rendered component
 */
export const renderUsingContextVersion = (component, DOMEl) => {
  const isReactDomV18 = typeof ReactDOM.createRoot === 'function';

  return isReactDomV18
    ? ReactDOM.createRoot(DOMEl).render(component)
    : ReactDOM.render(component, DOMEl);
};
